import { useEffect, useRef } from "react";
import "./ProjectHighlightCard.css";

function ProjectHighlightCard({
  title = {},
  titleColor = "",
  cardColor = "",
  cardTitleColor = "",
  cardDescColor = "",
  gridColoumns = 4,
  highlights = [],
  accentColor = "",
  animationDelayStep = 70,
}) {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.target.dataset.index - b.target.dataset.index)
          .forEach((entry) => {
            entry.target.classList.add("ph-visible");
            observer.unobserve(entry.target);
          });
      },
      { threshold: 0.2, rootMargin: "0px 0px -10% 0px" },
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const resizeCards = () => {
      let maxHeight = 0;
      cardsRef.current.forEach((card) => {
        if (card) {
          card.style.height = "auto"; // reset
          maxHeight = Math.max(maxHeight, card.offsetHeight);
        }
      });
      cardsRef.current.forEach((card) => {
        if (card) card.style.height = maxHeight + "px";
      });
    };

    resizeCards();
    window.addEventListener("resize", resizeCards);
    return () => window.removeEventListener("resize", resizeCards);
  }, [highlights]);

  const hexToRgb = (hex) => {
    let cleanHex = hex.replace("#", "");
    if (cleanHex.length === 3) {
      cleanHex = cleanHex.split("").map(c => c + c).join("");
    }
    const bigint = parseInt(cleanHex, 16);
    return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
  };

  return (
    <section id="project-highlights-section" className="ph-section"
      style={{
        "--accent-color": accentColor,
        "--accent-color-rgb": hexToRgb(accentColor),
      }}>
      <h2 className="ph-title" style={{ color: titleColor }}>{title}</h2>
      <div className="ph-grid" style={{ "--grid-columns": gridColoumns }}>
        {highlights.map((highlight, index) => {
          const Icon = highlight.icon;

          return (
            <div
              key={index}
              className="ph-card"
              ref={(el) => (cardsRef.current[index] = el)}
              style={{ animationDelay: `${index * animationDelayStep}ms`, backgroundColor: cardColor }}
              data-index={index}
            >
              <div className="ph-icon-wrap">
                <Icon size={22} strokeWidth={1.8} />
              </div>
              <h3 className="ph-card-title" style={{ color: cardTitleColor }}>{highlight.title}</h3>
              <p className="ph-card-desc" style={{ color: cardDescColor }}>{highlight.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default ProjectHighlightCard;
